import React from 'react';
import CircleProgress from '../../Utility/CircleProgress';
import { LoadingAnimation as LoadingAnimationType } from '../../../Types';
import { IconName } from '../../../SocketProvider';

const LoadingAnimation = ({ loadingAnimation }: { loadingAnimation: LoadingAnimationType }) => (
    <>
        <div className="flex items-center space-x-4">
            <CircleProgress progress={loadingAnimation.percentage} iconName={loadingAnimation.icon as IconName} />
            <span>{loadingAnimation.content}</span>
        </div>
        {loadingAnimation.image && (
            <img
                src={loadingAnimation.image}
                className="max-h-[400px] rounded-xl inline-block my-2 cursor-pointer"
                alt="Loading Animation"
            />
        )}
    </>
);

export default LoadingAnimation;
